<template>
  <div>
    <h3 class="mb-4">Registro da Chave de Acesso</h3>
    <v-text-field 
        v-model="email" 
        type="email" 
        readonly 
        filled 
        placeholder="Digite seu e-mail" 
        outlined
        dense    
    />
    <v-btn
        dark    
        color="primary"
        @click="iniciarCadastroBiometria"
        :class="$css_button"
        :loading="loadingWebAuthn"
    >
        {{ loadingWebAuthn ? 'Aguardando biometria...' : 'Cadastrar chave de acesso' }}
    </v-btn>
  </div>
</template>

<script>
import webauthnMixin from '@/mixins/webauthnMixin'; // Ajuste o caminho conforme seu projeto

export default {
    mixins: [webauthnMixin], // Injeta o estado e os métodos na instância deste componente

    computed: { 
        me () {
            return this.$store.state.auth.me
        },    
    },

    watch: {
        // Sempre que 'me' mudar, atualiza o email
        me: {
            immediate: true, // Executa assim que o componente carrega
            handler(newVal) {
                if (newVal && newVal.email) {
                    this.email = newVal.email;
                }
            }
        }
    },

    data() {
        return {
            email: ''
        };
    },

    methods: {
        async iniciarCadastroBiometria() {
            try {
                // authenticateWithPasskey vem diretamente do Mixin
                await this.registerCredential(this.email);
                this.$snotify.success('Cadastro com sucesso!');
                // this.$router.push('/dashboard');
            } catch (error) {
                // Log para ajudar a debugar se der outro erro no futuro
                console.error('Erro no registro WebAuthn:', error);

                // Verifica qual foi o tipo do erro
                if (error.name === 'InvalidStateError') {
                    // O dispositivo já tem uma chave registrada para este usuário
                    this.$snotify.warning('Este dispositivo já está cadastrado na sua conta!');
                } 
                else if (error.name === 'NotAllowedError') {
                    // O usuário cancelou a operação ou demorou muito
                    this.$snotify.info('Operação cancelada.');
                } 
                else {
                    // Qualquer outro erro genérico (falha de rede, erro no servidor, etc)
                    this.$snotify.error('Erro ao cadastrar chave de acesso. Tente novamente.');
                }
            }
        }
    }
};
</script>